import _ from 'underscore'
import colorsChart from '@/libs/colorsChart.js'

const translate = {
    'á': 'a',
    'é': 'e',
    'í': 'i',
    'ó': 'o',
    'ú': 'u'
};

const state = {
    comprador: '',
    estado: '',
    operacion: '',
    ordenDeCompra: '',
    ordenes: [],
    producto: '',
    proveedor: '',
    tipooperacion: ''
}

const mutations = {
    SET_ESTADO (state, estado) {
        state.estado = estado
    },
    SET_OPERACION (state, operacion) {
        state.operacion = operacion
    },
    SET_ORDEN_DE_COMPRA (state, ordenDeCompra) {
        state.ordenDeCompra = ordenDeCompra
    },
    SET_ORDENES (state, ordenes) {
        state.ordenes = ordenes
    },
    SET_PROVEEDOR (state, proveedor) {
        state.proveedor = proveedor
    },
    SET_PRODUCTO (state, producto) {
        state.producto = producto
    },
    SET_TIPOOPERACION (state, tipooperacion) {
        state.tipooperacion = tipooperacion
    }
}

const getters = {
    estados () {
        if (!state.ordenes || state.ordenes.length === 0) return []
        const estados = state.ordenes.map(item => item.estado)
        return _.unique(estados)
    },
    estadosTipoOperacion (state, getters) {
        if (!state.ordenes || state.ordenes.length === 0) return []
        const estados = []
        //obtenemos los tipos de operación
        const tipos = getters.tipooperaciones
        //iteramos los tipos de operación
        for (let i = 0; i < tipos.length; i++) {
            let estado = []
            state.ordenes.forEach( orden => { if(tipos[i] === orden.tipooperacion) estado.push(orden.estado) });
            estados.push({ tipo: tipos[i], data: _.unique(estado) })
        }
        return estados
    },
    progress (state, getters) {
        if (!state.ordenes || state.ordenes.length === 0) return []
        const progress = []
        //obtenemos los tipos de operación
        const tipos = getters.tipooperaciones
        //iteramos los tipos de operación
        for (let i = 0; i < tipos.length; i++) {
            let estado = []
            state.ordenes.forEach( orden => {
                if(tipos[i] === orden.tipooperacion) {
                    estado.push(orden.estadoprogreso)
                }
            });
            progress.push({ tipo: tipos[i], data: _.unique(estado) })
        }
        return progress
    },
    tipooperaciones () {
        if (!state.ordenes || state.ordenes.length === 0) return []
        const tipos = state.ordenes.map(item => item.tipooperacion)
        return _.unique(tipos)
    },
    estadosChart (state, getters) {
        const ordenes = getters.ordenesFiltered
        const labelStateTipo = getters.estadosTipoOperacion;
        const labelState = getters.estados;
        // const tipoOperacion = getters.tipooperaciones
        //por defecto en general que tome todos los estados con todos los tipos de operacion
        const data = { tipooperacion: 'general', data: [] }
        //si no hay un tipo de opacion seteado
        if (state.tipooperacion === '' || state.tipooperacion === undefined || state.tipooperacion === null){
           //iteramos sobre el array de progresos
            for (let i = 0; i < labelState.length; i++) {
               //obtenemos la data - estado de la operación
               const lookFor = labelState[i]
               //verificamos cuantos items hay 
               const count = ordenes.filter(orden => orden.estado === lookFor).length 
               //el estado lo convetimos a minusculas y sin espacios
               const estado = lookFor.replace(/\s+/g, '').toLowerCase()
               //remplazamos los acentos
               const unaccent = estado.replace(/[áéíóú]/g, (match) => { return translate[match] })
               //lo bucamos en la paleta de colores
               const color = colorsChart.findIndex( c => { return c.name === unaccent })
               //si se econtró 1 o mas coincidencias mandamos la data
               if (count > 0){
                   data.data.push({
                        name: lookFor, 
                        value: count,
                        itemStyle: color >= 0 ? { normal: { color: colorsChart[color].color } } : null
                   })
               }
           }
        }
        else{
            //consuletamos el estado y label por el tipo de operacion
            const label = labelStateTipo.findIndex( l => l.tipo === state.tipooperacion )
            //si se econtraron ambos entonces procedemos a llenar los datos correspondientes 
            if (label >= 0){
                //reasiganmos el tipo de operacion
                data.tipooperacion = state.tipooperacion
                //iteramos sobre el array de progresos
                for (let i = 0; i < labelStateTipo[label].data.length; i++) {
                    //obtenemos la data - estado de la operación
                    const lookFor = labelStateTipo[label].data[i]
                    //verificamos cuantos items hay 
                    const count = ordenes.filter(orden => orden.estado === lookFor && orden.tipooperacion == state.tipooperacion).length 
                    //el estado lo convetimos a minusculas y sin espacios
                    const estado = lookFor.replace(/\s+/g, '').toLowerCase()
                    //remplazamos los acentos
                    const unaccent = estado.replace(/[áéíóú]/g, (match) => { return translate[match] })
                    //lo bucamos en la paleta de colores
                    const color = colorsChart.findIndex( c => { return c.name === unaccent })
                    //si se econtró 1 o mas coincidencias mandamos la data
                    if (count > 0){
                        //asignamos la data
                        data.data.push({
                            name: lookFor, 
                            value: count,
                            itemStyle: color >= 0 ? { normal: { color: colorsChart[color].color } } : null
                       })
                    }
                }
            }
        }
        return data
    },
    ordenesDeCompra (state) {
        if (!state.ordenes || state.ordenes.length === 0) return []
        const ordenesDeCompra = state.ordenes.map(item => item.ordencompra)
        return _.unique(ordenesDeCompra)
    },
    ordenesFiltered (state) {
        //obtenemos los tipo de operacion
        // const tipoOperacion = getters.tipooperaciones
        // const comprador = state.comprador.toLowerCase()
        const estado = state.estado ? state.estado.toLowerCase() : ''
        const ordenDeCompra = state.ordenDeCompra ? state.ordenDeCompra.toLowerCase() : ''
        const producto = state.producto ? state.producto.toLowerCase() : ''
        const proveedor = state.proveedor ? state.proveedor.toLowerCase() : ''
        const tipooperacion = state.tipooperacion ? state.tipooperacion.toLowerCase() : ''
        return state.ordenes.filter(item => {
            return item.estado.toLowerCase().includes(estado) &&
                item.ordencompra.toLowerCase().includes(ordenDeCompra) &&
                item.proveedor.toLowerCase().includes(proveedor) &&
                item.producto.toLowerCase().includes(producto) && 
                item.tipooperacion.toLowerCase().includes(tipooperacion)
        })
    },
    productos (state) {
        if (!state.ordenes || state.ordenes.length === 0) return []
        const productos = state.ordenes.map(item => item.producto)
        return _.unique(productos)
    },
    proveedores (state) {
        if (!state.ordenes || state.ordenes.length === 0) return []
        const proveedores = state.ordenes.map(item => item.proveedor)
        return _.unique(proveedores)
    }
}

export default { getters, mutations, state }